export enum VehicleReservationSearchSortEnum {
  RentalScore = 1,
  Price = 2,
  Odometer = 3
}
